import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../components/Form/Field'
import ObjectiveWarningMessage from '../../../../../../Multiplatform/UploadAdCreative/ObjectiveWarningMessage'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'
import RemainingCampaignImpressionsBudgetFields from '../../../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/RemainingCampaignImpressionsBudgetFields'
import ToggleField from '../../../../../../../components/Form/ToggleField'
import MissingDataWarnings from '../MissingDataWarnings'

import { getIsObjectiveEquivalentToReach } from '../../../../../../Multiplatform/UploadAdCreative/helpers'
import { getShowBudgetSection } from '../../../../../../Multiplatform/CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/helper'
import { useFormattedObjectivesList, useObjectivesListIsLoading } from '../hooks'

import { OUTCOME_AWARENESS } from '../../../../../../../constants/campaigns'
import { OBJECTIVE } from '../../../../../../Multiplatform/CampaignForms/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import useAutoOptimiseToggleLabelStyles from '../../../../../../../styles/common/autoOptimiseToggleLabelStyles'

import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../../../reusableFields'
import AppPromotionIos14Fields from '../AppPromotionIos14Fields'

const NewCampaignImpressionAllocationFields = ({ formik, remainingImpressions }) => {
  const { t } = useTranslation()

  const classes = useAutoOptimiseToggleLabelStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { values, setFieldValue } = formik

  const campaignObjective = values[OBJECTIVE]

  const showBudgetSection = getShowBudgetSection(values[OBJECTIVE])

  const isObjectiveEquivalentToReach = getIsObjectiveEquivalentToReach(campaignObjective)

  const formattedObjectivesList = useFormattedObjectivesList()
  const isObjectivesListLoading = useObjectivesListIsLoading()

  // user cannot select awareness if allocation is impressions because a cost cap cannot be added
  const impressionsAllocationObjectivesList = useMemo(() => {
    return formattedObjectivesList.filter(item => item.value !== OUTCOME_AWARENESS)
  }, [formattedObjectivesList])

  if (remainingImpressions < 1) {
    return <ErrorMessage fontSize={14} error="Your remaining impressions are too low to create a campaign." />
  }

  return (
    <div className={drawerFormClasses.subSection}>
      <FieldLabelWrapper label={t('Campaign goal')}>
        <p>{t('To upload the ad to a new campaign, please select the campaign optimisation goal.')}</p>
        <Field
          name={OBJECTIVE}
          label="Goal"
          placeholder="Select goal..."
          formik={formik}
          options={impressionsAllocationObjectivesList}
          isLoading={isObjectivesListLoading}
        />
      </FieldLabelWrapper>
      <MissingDataWarnings values={values} />
      {!isObjectiveEquivalentToReach && <ObjectiveWarningMessage />}

      {showBudgetSection && (
        <div className={drawerFormClasses.subSection}>
          <ToggleField
            name={AUTO_OPTIMIZED_CAMPAIGN_BUDGET}
            isEnabled={values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]}
            setFieldValue={setFieldValue}
            label={'Auto optimised campaign budget'}
            labelClassName={classes.autoOptimiseToggleLabel}
            isSolid={false}
          />
          {values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET] && (
            <RemainingCampaignImpressionsBudgetFields
              formik={formik}
              remainingImpressions={remainingImpressions}
              impressionsFieldPlaceholder={'Impressions budget'}
            />
          )}
        </div>
      )}
      <AppPromotionIos14Fields formik={formik} />
    </div>
  )
}

export default NewCampaignImpressionAllocationFields
